<template>
  <div class="VersionUpdate">
    <div class="pop" :show="show" @touchmove.stop=''>
      <div>
        <div class="imgs">
          <img src="./../assets/img/version_update_bg.png" alt="">
          <div class="title">发现新版本</div>
          <div class="num">V{{info.version}}</div>
        </div>
        <div class="desc">
          <div>
            <p v-for="(item,index) in desc" :key="index">{{item}}</p>
          </div>
        </div>
        <div class="btns">
          <span v-if="info.is_compel != 1" @click="handleCancel">稍后更新</span>
          <span @click="handleConfirm" class="down">立即更新</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VersionUpdate',
  data(){
    return {
      show:false,
      info:{
        version:'',
        url:'',
        is_compel:"1",
        content:""
      },
      desc:[]
    }
  },
  mounted(){

  },
  methods:{
    // 显示弹窗
    showPop(data){
      this.info.version = data.version
      this.info.is_compel = data.is_compel
      this.info.url = data.url
      this.info.content = data.content || "新版本发布啦！更多功能优化，赶快来体验吧。"
      this.desc = this.info.content.split("\n")
      this.show = true
    },
    hidePop(){
      this.show = false
    },


    // 稍后更新
    handleCancel(){
      this.hidePop()
    },
    // 立即更新
    handleConfirm(){
      // plus.runtime.openURL(this.info.url);
      let apkUrl = this.info.url
      plus.nativeUI.showWaiting("下载中...");
      var dtask = plus.downloader.createDownload(apkUrl, {}, function (d, status) {
        plus.nativeUI.closeWaiting();
        if (status == 200) {
          var path = d.filename;//下载apk
          plus.nativeUI.showWaiting("安装中...");
          // force:false进行版本号校验，如果将要安装应用的版本号不高于现有应用的版本号则终止安装，并返回安装失败
          plus.runtime.install(path,{force:true},function(){
            plus.nativeUI.closeWaiting();
            this.show = false
            plus.nativeUI.alert("应用资源更新完成！",function(){
              plus.runtime.restart();
            });
          },function(e){
            plus.nativeUI.closeWaiting();
            console.log("安装失败[" + e.code + "]：" + e.message);
            plus.nativeUI.alert("应用资源更新失败[" + e.code + "]：" + e.message);
            this.show = false
          });
        } else {
          // plus.nativeUI.alert('版本更新失败:' + status);
          this.$toast.failed('版本更新失败:' + status);
        }
      });
      dtask.start();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.VersionUpdate{
  .pop{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999999999;
    background-color: rgba(0,0,0,0.5);
    transition: 0.3s all;
    opacity: 0;
    visibility: hidden;
    &[show]{
      opacity: 1;
      visibility: visible;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    &>div{
      width: 4rem;
      margin-top: -1rem;
      overflow: hidden;
      .imgs{
        width: 100%;
        position: relative;
        display: flex;
        img{
          width: 100%;
          height: 2.8rem;
        }
        div{
          position: absolute;
          color: #086A42;
          letter-spacing: 0.02rem;
          &.title{
            left: 0.18rem;
            top: 0.9rem;
            font-weight: bold;
            font-size: 0.32rem;
          }
          &.num{
            left: 50%;
            transform: translateX(-50%);
            margin-left: -0.6rem;
            bottom: 1.1rem;
            height: 0.32rem;
            background-color: #fff;
            border-radius: 0.22rem;
            font-size: 0.20rem;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 0.16rem;
          }
        }
      }
      .desc{
        padding: 0 0.2rem;
        padding-bottom: 0.2rem;
        box-sizing: content-box;
        background-color: #fff;
        font-size: 0.22rem;
        overflow: auto;
        min-height: 1rem;
        max-height: 2rem;
        &>div{
          color: #666;
          letter-spacing: 0.02rem;
          text-align: justify;
        }
      }
      .btns{
        height: 0.8rem;
        padding: 0 0.2rem;
        padding-bottom: 0.25rem;
        background-color: #fff;
        border-radius: 0 0 0.1rem 0.1rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        span{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 1.5rem;
          height: 0.5rem;
          font-size: 0.22rem;
          background-color: #F4F8FB;
          color: #333;
          border-radius: 0.06rem;
          &:active{
            background-color: #f4f4f4;
          }
          &.down{
            color: #fff;
            background:linear-gradient(-90deg,rgba(23,229,145,1),rgba(26,194,125,1));
            &:active{
              background:linear-gradient(-90deg,rgba(23,229,145,0.8),rgba(26,194,125,0.8));
            }
          }
        }
      }
    }
  }
}
</style>
